import React, { useEffect } from 'react'
import { Button, Form, Input, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { loginUser, userSelector, clearState } from '../../store/session'
import useAuth from '../../app/hooks/useAuth'
import { AUTH_TOKEN_KEY } from '../../app/contants'
import './style.css'

const messageKey = 'login'

const Login = () => {
  const { setAuthToken } = useAuth()
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const { isFetching, isSuccess, isError, errorMessage } = useSelector(userSelector)

  useEffect(() => {
    return () => {
      dispatch(clearState())
    }
  }, [])

  useEffect(() => {
    if (isFetching) {
      message.loading({ content: 'Загрузка...', key: messageKey })
    }
  }, [isFetching])

  useEffect(() => {
    if (isError && !isFetching) {
      message.error({ content: 'Ошибка авторизации', key: messageKey }, 2).then(() => {})
    }
  }, [isError, isFetching])

  const onFinish = ({ username, password }) => {
    dispatch(
      loginUser({
        username,
        password,
      })
    )
  }

  useEffect(() => {
    const authToken = localStorage.getItem(AUTH_TOKEN_KEY)
    if (!isFetching && isSuccess && authToken) {
      message.success({ content: 'Авторизация прошла успешно', key: messageKey }, 0.5)
      setAuthToken(authToken)
      navigate('/applications', { replace: true })
    }
  }, [isFetching, isSuccess, navigate])

  const onFinishFailed = (errorInfo) => {
    // TODO: error handling
    console.log('Failed:', errorInfo)
  }

  return (
    <div className="container">
      <div className="form-container">
        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          size="large"
        >
          <Form.Item
            label="Пользователь"
            name="username"
            rules={[{ required: true, message: 'Введите имя пользователя' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Пароль" name="password" rules={[{ required: true, message: 'Введите пароль' }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Войти
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Login
